import React, { useEffect, useState } from "react";
import "./profile.css";
import { Container, Spinner } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getuserprofileaction,
  resetPasswordaction,
  updateUserProfileDataaction,
} from "../../redux/actions/AuthAction";
import notify from "../../Notifcation";
import { ToastContainer } from "react-toastify";
const Profile = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [Ispress, setIspress] = useState(false);
  const [IspressPass, setIspressPass] = useState(false);
  const [loadingPASS, setloadingPASS] = useState(true);
  const [Name, setName] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [Phone, setPhone] = useState("");
  const [Email, setEmail] = useState("");
  const [Passwordp, setPasswordp] = useState("password");
  const [Passwordc, setPasswordc] = useState("password");
  const [Passwordo, setPasswordo] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordInputOld, setPasswordInputOld] = useState("");
  const [ConfirmpasswordInput, setConfirmPasswordInput] = useState("");
  const userdata = useSelector((state) => state.authReducer.userProfile);
  useEffect(() => {
    dispatch(getuserprofileaction());
  }, []);
  useEffect(() => {
    if(userdata){
    setEmail(userdata.email);
    setPhone(userdata.mobile);
    setNationalid(userdata.national_id);
    setName(userdata.username);
  }
  }, [userdata]);
  const togglep = () => {
    if (Passwordp === "password") {
      setPasswordp("text");
      return;
    }
    setPasswordp("password");
  };
  const toggleo = () => {
    if (Passwordo === "password") {
      setPasswordo("text");
      return;
    }
    setPasswordo("password");
  };
  const togglec = () => {
    if (Passwordc === "password") {
      setPasswordc("text");
      return;
    }
    setPasswordc("password");
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Phone === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setLoading(true);
    setIspress(true);
    const formData = new FormData();
    formData.append("mobile", Phone);
    formData.append("image", "image");
    formData.append("language", "A");
    await dispatch(updateUserProfileDataaction(formData));
    setLoading(false);
    setIspress(false)
  };
  const handlesubmitChangePasssword = async (e) => {
    e.preventDefault();
    if (
      passwordInputOld === "" ||
      passwordInput === "" ||
      ConfirmpasswordInput === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (ConfirmpasswordInput !== passwordInput) {
      notify("يجب ان تكون كلمة السر متطابقة", "error");
      return;
    }
    setIspressPass(true);
    await dispatch(
      resetPasswordaction({
        password: passwordInputOld,
        new_password: passwordInput,
        new_password_confirmation: ConfirmpasswordInput,
      })
    );
    setloadingPASS(false);
    setIspressPass(false);
    setPasswordInputOld("");
    setPasswordInput("");
    setConfirmPasswordInput("");
  };
  const reschangepass = useSelector(
    (state) => state.authReducer.userChangePassword
  );
  useEffect(() => {
    if (loadingPASS === false) {
      setTimeout(() => setloadingPASS(true), 1500);
      if (reschangepass) {
          if (reschangepass.status === 200||reschangepass.status === 201) {
            if (reschangepass.data) {
              notify(reschangepass.data.message, "success");
              localStorage.setItem("token", reschangepass.data.token);
            }
          }
          else if (reschangepass.status !== 200||reschangepass.status !== 201) {
            if (reschangepass.data) {
              notify(reschangepass.data.message, "error");
            }else notify("حدث خطأ حاول مرة اخرى", "error");
          } 
      } 
    }
  }, [loadingPASS]);
  const res = useSelector((state) => state.authReducer.updateuserProfile);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 200||res.status === 201) {
          if (res.data) {
            notify("تم تحديث البيانات بنجاح", "success");
          } 
        }
        else if (res.status !== 200||res.status !== 201) {
          if (res.data) {
            res.data.messages.map((message) => notify(message, "error"));
          }else notify("حدث خطأ حاول مرة اخرى", "error");
        } 
      }
    }
  }, [loading]);
  return (
    <>
      <Container>
        <h4 className="text-center mt-3 mb-3">البيانات الشخصية</h4>
        <div className="inputs-container">
          <div className="inp-container ">
            <TextField
              focused
              label="اسم المستخدم"
              onChange={() => notify("لايمكن تغيير اسم المستخدم ", "error")}
              variant="outlined"
              value={Name}
            />
          </div>
          <div className="inp-container ">
            <TextField
              label="الرقم القومي"
              type="number"
              value={Nationalid}
              onChange={() => notify("لايمكن تغيير الرقم القومي ", "error")}
              variant="outlined"
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography
                >
              رقم الهاتف
                  <span style={{ color: "red", fontSize: "21px" }}>
                    *
                  </span>
                </Typography>
              }
              type="number"
              value={Phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              variant="outlined"
            />
          </div>
          <div className="inp-container ">
            <TextField
              label="البريد الألكتروني"
              type="email"
              value={Email}
              onChange={() =>
                notify("لايمكن تغيير البريد الألكتروني  ", "error")
              }
              variant="outlined"
            />
          </div>
          <div className="inp-container "></div>

          <div className="inp-container "></div>
        </div>
        {loading &&Ispress? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            حفظ التعديلات
          </button>
        )}
        <div className="inputs-container">
          <div className="inp-container ">
            <TextField
              label="كلمة المرور القديمة"
              type={Passwordo}
              onChange={(e) => setPasswordInputOld(e.target.value)}
              value={passwordInputOld}
              variant="outlined"
            />
            <button onClick={toggleo} className="eye">
              {Passwordo === "password" ? (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-slash-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                </svg>
              )}
            </button>
          </div>
          <div className="inp-container ">
            <TextField
              label="كلمة المرور الجديدة"
              type={Passwordp}
              onChange={(e) => setPasswordInput(e.target.value)}
              value={passwordInput}
              variant="outlined"
            />
            <button onClick={togglep} className="eye">
              {Passwordp === "password" ? (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-slash-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                </svg>
              )}
            </button>
          </div>
          <div className="inp-container ">
            {" "}
            <TextField
              label="تأكيد كلمة المرور الجديدة"
              type={Passwordc}
              onChange={(e) => setConfirmPasswordInput(e.target.value)}
              value={ConfirmpasswordInput}
              variant="outlined"
            />
            <button onClick={togglec} className="eye">
              {Passwordc === "password" ? (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-slash-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                </svg>
              )}
            </button>
          </div>
          <div className="inp-container "></div>
        </div>
        {loadingPASS&&IspressPass ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmitChangePasssword}>
            حفظ
          </button>
        )}
      </Container>
      <ToastContainer />
    </>
  );
};

export default Profile;
